// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__2Bx6w","row":"ProcedureTreatmentSummary_row__1Iawb"};